module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-resize-bar"
  }, [_c('div', {
    staticClass: "g-resize-highlight",
    style: ({
      width: _vm.left + '%',
    })
  }), _vm._v(" "), _c('button', {
    staticClass: "circle-btn",
    style: ({
      left: _vm.left + '%',
    }),
    on: {
      "touchstart": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.drag($event)
      },
      "mousedown": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.drag($event)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb9adcba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-core-image-upload/dist/resize-bar.vue
// module id = 432
// module chunks = 3